export const CommentTypes = [
	{ color: '#8BEA67', value: 'positiv', label: 'Positive' },
	{ color: '#FF3D62', value: 'negativ', label: 'Négative' },
	{ color: '#D4DCE5', value: 'all', label: 'Neutre' },
]



// WEBPACK FOOTER //
// ./src/config/enum/CommentTypes.js